import { atom } from 'recoil';

// eslint-disable-next-line import/prefer-default-export
export const quickViewSearchUseLocationAtom = atom({ key: 'quickViewSearchUseLocationAtom', default: false });
